var close = "https://shopfront-cdn.tekoapis.com/static/0364832d695974bf.svg";

export { close as default };
